import React from 'react';
import HelpIcon from '@moda/icons/help-16';
import { Popover, Stack, Text, useBreakpoint } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemShippingDetails.scss';

type Props = {
  granularity?: 'minimal' | 'full';
  item: LineItem;
};

export const LineItemShippingDetails: React.FC<Props> = ({
  granularity = 'full',
  item: {
    attributes: { expectedDeliveryTime, returnPolicy, isAvailableNow }
  }
}) => {
  const { matches: isDesktop } = useBreakpoint({ gt: 'md' });

  return (
    <Stack space={4}>
      {expectedDeliveryTime && (
        <Stack space={1} direction="horizontal" alignItems="center">
          <Text>{expectedDeliveryTime}</Text>
          {granularity === 'full' && !isAvailableNow && (
            <Popover
              anchor={isDesktop ? 'bottomCenter' : 'bottomRight'}
              content={
                <div className="LineItemShippingDetails__popover-content">
                  You're ordering from next season's collection, and producing your piece may take
                  several months.
                </div>
              }
            >
              <HelpIcon />
            </Popover>
          )}
        </Stack>
      )}
      {granularity === 'full' && returnPolicy && <div>{returnPolicy}</div>}
      {!isAvailableNow && (
        <div>
          RESERVE TODAY
          <div>
            An advance payment of 50% is required at checkout.
            {granularity === 'full' &&
              ' The remaining balance will be charged when the item ships.'}
          </div>
        </div>
      )}
    </Stack>
  );
};
